export * from './lib/acquisition.module';
